/// <amd-module name="Test/Analytics/Widgets/PointHistoryWidget/PointHistoryWidgetConstants" />

export const PointHistoryFields = {
    TotalCount: "TotalCount",
    Passed: "Passed",
    Failed: "Failed",
    Blocked: "Blocked",
    NotApplicable: "NotApplicable",
    NotExecuted: "NotExecuted",
    Executed: "Executed",
    DateSK: "DateSK"
}

export enum PointHistoryCommands {
    Last14Days,
    Last30Days,
    CustomDate
}